module.exports = __webpack_public_path__ + "static/media/mobile-bg.9c572c13.svg";